import {AfterViewInit, Component, computed, HostListener, inject, OnInit, signal} from '@angular/core';
import {NavigationEnd, Router, RouterLink} from "@angular/router";
import {NavListComponent} from "./nav-list/nav-list.component";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {gsap} from "gsap";
import {AccountService} from "../../services/account/account.service";
import {TAccountAction} from "./nav-list/menu.types";
import {CabinetMenuListComponent} from "../../cabinet/cabinet-menu-list/cabinet-menu-list.component";
import {NgOptimizedImage} from "@angular/common";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {LanguageButtonComponent} from "../../components/button/language-button.component";
import {filter} from "rxjs";
import {ReferralCabinetMenuComponent} from "../../referral/cabinet/referral-cabinet-menu.component";

@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    NavListComponent,
    ReactiveFormsModule,
    CabinetMenuListComponent,
    NgOptimizedImage,
    TranslatePipe,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    LanguageButtonComponent,
    ReferralCabinetMenuComponent
  ],
  templateUrl: './header.component.html',
  styles: ``
})
export class HeaderComponent implements OnInit, AfterViewInit {
  showNavbar = signal(true);
  isCabinetRoute = signal(false);
  isReferralCabinetRoute = signal(false);
  isOnboardingRoute = signal(false);
  account = inject(AccountService);
  #translateService = inject(TranslateService);
  #fb = inject(FormBuilder);
  #accountService = inject(AccountService);
  expandMainNavbar = signal(false);


  activeLang = signal({
    lang: 'ru',
    value: 'Ru',
    img: '/images/flags/russia.svg'
  })

  langList = signal([
    {lang: 'ru', value: 'Рус', img: '/images/flags/russia.svg'},
    {lang: 'en', value: 'English', img: '/images/flags/united-kingdom.svg'},
    {lang: 'uz', value: 'Uzbek', img: '/images/flags/uzbekistan.svg'},
  ])

  langModel: FormGroup = this.#fb.group({
    lang: 'ru'
  })

  @HostListener('window:resize', ['$event.target.innerWidth']) onResize(width: number) {
    if (!this.showNavbar()) {
      return;
    }

    if (width > 992) {
      this.showNavbar.set(false);
    }
  }

  ngOnInit(): void {
    const lang = localStorage.getItem("lang");
    if (lang) {
      const active = this.langList().find(item => item.lang === lang);
      if (active) {
        this.activeLang.set(active);
      }
      this.langModel.patchValue({
        lang: lang,
      });
    }
  }

  constructor(private router: Router) {
    this.isCabinetRoute.set(this.isCabinetUrl(this.router.url));
    this.isReferralCabinetRoute.set(this.isReferralCabinetUrl(this.router.url));

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.isCabinetRoute.set(this.isCabinetUrl(e.urlAfterRedirects));
        this.isReferralCabinetRoute.set(this.isReferralCabinetUrl(e.urlAfterRedirects));
      });

    this.isOnboardingRoute.set(
      this.router.url.startsWith('/onboarding')
    );

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.isOnboardingRoute.set(
          e.urlAfterRedirects.startsWith('/onboarding')
        );
      });
  }


  ngAfterViewInit(): void {
    const tl = gsap.timeline();

    tl.from('.navbar-logo', {
      opacity: 0,
      x: '-150px',
      duration: 0.3,
    }).from('.navbar-actions', {
      x: '150px',
      opacity: 0,
      duration: 0.3,
    }, '-=0.3').from('.nav-list__item', {
      opacity: 0,
      scaleX: 0,
      stagger: 0.1,
      x: 50,
      y: -10,
      duration: 0.2,
    })
  }

  expandNavbar(): void {
    this.expandMainNavbar.update(val => !val);
  }

  changeLanguage(item: { lang: string, value: string, img: string }): void {
    // const lang: 'uz' | 'ru' | 'en' = event.target.value;
    this.activeLang.set(item);
    localStorage.setItem('lang', item.lang);
    window.location.reload();
  }

  closeMenu(): void {
    if (!this.showNavbar()) {
      return;
    }

    this.expandNavbar();
  }

  async openAuth(): Promise<void> {
    await this.#accountService.showAction();
  }

  async logout(): Promise<void> {
    await this.#accountService.logout('exit');
  }

  async onAction(actionType: TAccountAction): Promise<void> {
    if (actionType === 'logout') {
      await this.logout();
    } else {
      await this.openAuth();
    }
  }

  showCabinetMenu = computed(() =>
    !this.expandMainNavbar() &&
    this.account.isLoggedIn() &&
    this.isCabinetRoute()
  );

  showMainNav = computed(() =>
    this.expandMainNavbar() &&
    this.isCabinetRoute()
  );

  private isCabinetUrl(url: string): boolean {
    return url.startsWith('/cabinet') || url.startsWith('/referral-cabinet');
  }

  private isReferralCabinetUrl(url: string): boolean {
    return url.startsWith('/referral-cabinet');
  }

  // get isCabinet(): boolean {
  //   return window.location.pathname.includes('cabinet');
  // }
}
